import React from 'react';
import LegalPageLayout, { LegalSection, LegalSubtitle, LegalText, LegalList } from '../../components/LegalPageLayout';

const PrivacidadPage = () => {
  return (
    <LegalPageLayout
      title="Política de Privacidad"
      description="Política de privacidad de Web a Bajo Coste. Información sobre el tratamiento de datos personales y derechos RGPD."
      canonical="https://webabajocoste.es/legal/privacidad"
    >
      <LegalSection>
        <LegalSubtitle>1. Responsable del tratamiento</LegalSubtitle>
        <LegalText>
          De conformidad con lo establecido por el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, 
          y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos 
          digitales, le informamos que los datos personales que nos facilite a través de nuestro sitio web serán tratados por:
        </LegalText>
        <LegalList>
          <li>Denominación social: Candle Dropstore Sociedad Limitada</li>
          <li>CIF: B19327030</li>
          <li>Domicilio social: Calle Merced 20 1C, Guadalajara 19001, España</li>
          <li>Teléfono: +34 628 774 688</li>
          <li>Email: hola@webabajocoste.es</li>
        </LegalList>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>2. Finalidad del tratamiento</LegalSubtitle>
        <LegalText>
          Los datos personales que nos proporcione serán tratados con las siguientes finalidades:
        </LegalText>
        <LegalList>
          <li>Gestionar las consultas, solicitudes o peticiones realizadas a través de los formularios de contacto.</li>
          <li>Enviar comunicaciones comerciales sobre nuestros servicios, siempre y cuando haya dado su consentimiento expreso para ello.</li>
          <li>Cumplir con las obligaciones legales que nos resulten directamente aplicables y regulen nuestra actividad.</li>
          <li>Proteger y ejercer nuestros derechos o responder ante reclamaciones de cualquier índole.</li>
          <li>Elaborar perfiles comerciales en base a la información facilitada para poder ofrecerle productos y servicios adecuados a sus preferencias, así como mejorar su experiencia de usuario.</li>
        </LegalList>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>3. Legitimación del tratamiento</LegalSubtitle>
        <LegalText>
          El tratamiento de sus datos se realiza con las siguientes bases jurídicas:
        </LegalText>
        <LegalList>
          <li>La ejecución de un contrato en el que el interesado es parte o para la aplicación de medidas precontractuales.</li>
          <li>El consentimiento del interesado para el tratamiento de sus datos personales para uno o varios fines específicos.</li>
          <li>El interés legítimo del responsable del tratamiento o de un tercero.</li>
          <li>El cumplimiento de obligaciones legales aplicables al responsable del tratamiento.</li>
        </LegalList>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>4. Conservación de los datos</LegalSubtitle>
        <LegalText>
          Los datos personales proporcionados se conservarán mientras se mantenga la relación comercial o no solicite su supresión y
          durante el plazo por el cual pudieran derivarse responsabilidades legales por los servicios prestados.
        </LegalText>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>5. Destinatarios de los datos</LegalSubtitle>
        <LegalText>
          Sus datos personales podrán ser comunicados a:
        </LegalText>
        <LegalList>
          <li>Las Administraciones Públicas en los casos previstos por la Ley.</li>
          <li>Otras empresas del grupo empresarial para fines administrativos internos.</li>
          <li>Proveedores de servicios necesarios para el correcto cumplimiento de las obligaciones contractuales.</li>
        </LegalList>
        <LegalText>
          No se realizarán transferencias internacionales de datos fuera del Espacio Económico Europeo.
        </LegalText>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>6. Derechos de los interesados</LegalSubtitle>
        <LegalText>
          Como titular de los datos, usted tiene derecho a:
        </LegalText>
        <LegalList>
          <li>Acceder a sus datos personales.</li>
          <li>Solicitar la rectificación de los datos inexactos.</li>
          <li>Solicitar su supresión cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.</li>
          <li>Solicitar la limitación del tratamiento de sus datos.</li>
          <li>Oponerse al tratamiento de sus datos.</li>
          <li>Solicitar la portabilidad de los datos.</li>
          <li>Retirar el consentimiento prestado.</li>
        </LegalList>
        <LegalText>
          Puede ejercer estos derechos enviando un correo electrónico a hola@webabajocoste.es, adjuntando copia de su DNI o documento equivalente.
          También tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es) si considera 
          que el tratamiento no se ajusta a la normativa vigente.
        </LegalText>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>7. Procedencia de los datos</LegalSubtitle>
        <LegalText>
          Los datos personales que tratamos proceden de:
        </LegalText>
        <LegalList>
          <li>El propio interesado o su representante legal.</li>
          <li>Fuentes accesibles al público.</li>
          <li>Terceros con los que tenemos acuerdos de colaboración.</li>
        </LegalList>
        <LegalText>
          Las categorías de datos que tratamos son:
        </LegalText>
        <LegalList>
          <li>Datos identificativos: nombre, apellidos, DNI, dirección, teléfono, email.</li>
          <li>Datos económicos: para la facturación.</li>
          <li>Información comercial: servicios contratados.</li>
        </LegalList>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>8. Medidas de seguridad</LegalSubtitle>
        <LegalText>
          Hemos adoptado las medidas técnicas y organizativas necesarias para garantizar la seguridad de sus datos personales 
          y evitar su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del estado de la tecnología, 
          la naturaleza de los datos almacenados y los riesgos a que están expuestos.
        </LegalText>
      </LegalSection>
      
      <LegalText>
        Fecha de la última actualización: 28 de marzo de 2023
      </LegalText>
    </LegalPageLayout>
  );
};

export default PrivacidadPage; 